import { c as _c } from "react/compiler-runtime";
import { LazyImage } from "@website/ui/lazy-image";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import { useEffect, useState } from "react";
import background from "./assets/commentsback.png";
import backgroundMobile from "./assets/commentsbackmobile.png";
import coat from "./coat.png";
import type { HostExperienceItem, VillaHostExperienceCarouselProperties } from "./villa-host-experience-carousel.types";
const AUTO_SLIDE_INTERVAL_IN_MS = 10_000;
const TestimonialSlide = t0 => {
  const $ = _c(24);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item.title) {
    t1 = <div className="pb-10 text-xl font-bold max-lg:pb-7 lg:text-2xl">{item.title}</div>;
    $[0] = item.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LazyImage alt="" src={coat.src} className="pb-2 max-lg:max-w-8" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== item.name) {
    t3 = <p className="text-subtitle-1 pb-2">{item.name}</p>;
    $[3] = item.name;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== item.role) {
    t4 = <p className="text-body-2 text-on-surface-medium-emphasis lg:text-body-1 w-max max-lg:pl-2">{item.role}</p>;
    $[5] = item.role;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="items-center justify-center gap-4 max-lg:flex">{t2}<div>{t3}{t4}</div></div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== item.quote) {
    t6 = <div className="flex h-full max-w-[526px] items-center rounded-2xl bg-white p-4 text-xs leading-7">{item.quote}</div>;
    $[10] = item.quote;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="flex items-center gap-1 max-lg:flex-col max-lg:items-start lg:h-32 lg:gap-4">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t1 || $[16] !== t7) {
    t8 = <div className="flex flex-col">{t1}{t7}</div>;
    $[15] = t1;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== item.name || $[19] !== item.pic) {
    t9 = <div className="rounded-3xl bg-white/70"><LazyImage alt={item.name} src={item.pic} /></div>;
    $[18] = item.name;
    $[19] = item.pic;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t8 || $[22] !== t9) {
    t10 = <div className="flex size-full items-center justify-between max-lg:flex-col max-lg:gap-7 xl:mx-auto xl:max-w-[1200px] xl:px-0">{t8}{t9}</div>;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};
const Component = t0 => {
  const $ = _c(30);
  const {
    testimonials
  } = t0;
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      initial: 0,
      rtl: true,
      renderMode: "performance",
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      },
      loop: true,
      slides: {
        perView: 1,
        spacing: 0
      },
      mode: "free-snap"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [sliderReference, instanceReference] = useKeenSlider(t1);
  let t2;
  let t3;
  if ($[1] !== instanceReference || $[2] !== testimonials.length) {
    t2 = () => {
      if (testimonials.length <= 1) {
        return;
      }
      const intervalId = window.setInterval(() => {
        instanceReference.current?.next();
      }, AUTO_SLIDE_INTERVAL_IN_MS);
      return () => window.clearInterval(intervalId);
    };
    t3 = [instanceReference, testimonials.length];
    $[1] = instanceReference;
    $[2] = testimonials.length;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t10;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== currentSlide || $[6] !== loaded || $[7] !== sliderReference || $[8] !== testimonials) {
    const slides = testimonials.map(_temp);
    t8 = "bg-dim-background relative overflow-hidden";
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <div className="absolute inset-y-0 right-0 hidden w-1/2 bg-right bg-no-repeat lg:block" style={{
        backgroundImage: `url(${background.src})`,
        backgroundSize: "cover"
      }} />;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <div className="absolute inset-y-0 block w-full bg-right bg-no-repeat lg:hidden" style={{
        backgroundImage: `url(${backgroundMobile.src})`,
        backgroundSize: "cover"
      }} />;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    t7 = "relative z-10 p-6 lg:py-10";
    t4 = "group relative size-full";
    t5 = <section className="keen-slider size-full" ref={sliderReference}>{slides.map(_temp2)}</section>;
    t6 = loaded && <div className="bg-on-color-disable z-1 absolute -bottom-6 right-1/2 flex translate-x-1/2 gap-1 rounded-full px-2.5 py-1">{slides.map((_, index_1) => <div className={`size-1.5 rounded-full ${currentSlide === index_1 ? "bg-on-surface-secondary-high-emphasis" : "bg-on-surface-disable-info"}`} key={`villa-host-experience-dot-${index_1}`} />)}</div>;
    $[5] = currentSlide;
    $[6] = loaded;
    $[7] = sliderReference;
    $[8] = testimonials;
    $[9] = t10;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t10 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  let t11;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t11 = <article className={t4}>{t5}{t6}</article>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t7) {
    t12 = <div className={t7}>{t11}</div>;
    $[22] = t11;
    $[23] = t7;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t12 || $[27] !== t8 || $[28] !== t9) {
    t13 = <div className={t8}>{t9}{t10}{t12}</div>;
    $[25] = t10;
    $[26] = t12;
    $[27] = t8;
    $[28] = t9;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};
export const VillaHostExperienceCarousel = Component;
function _temp(item, index) {
  return <TestimonialSlide item={item} key={`${item.name}-${index}`} />;
}
function _temp2(slide, index_0) {
  return <article className="keen-slider__slide w-full !overflow-visible" key={`villa-host-experience-slide-${index_0}`}>{slide}</article>;
}